import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const MethodCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  border: 1px solid ${COLORS.strokeStatic};
  border-radius: 16px;
  background-color: ${COLORS.bgWhite};
`

export const MethodHeading = styled.h2`
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textPrimary};
`

export const OptionRow = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  padding: 8px 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
`

/** "카드 결제" 라디오 ↔ 카드 캐러셀 사이 시안 간격 (텍스트 기준 16px) */
export const CardCarouselWrap = styled.div`
  margin-top: 8px;
`

export const OptionLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textPrimary};
`

export const LogoBadge = styled.img`
  width: 40px;
  height: 24px;
  object-fit: contain;
`

export const RadioOuter = styled('span', {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 9999px;
  ${({ selected }) =>
    selected
      ? `background-color: ${COLORS.brand};`
      : `border: 2px solid ${COLORS.strokeInput}; background-color: ${COLORS.bgWhite};`}
`

export const RadioInner = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  background-color: ${COLORS.bgWhite};
`

